export default "__VITE_ASSET__B7r79wo3__"